/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContactCreateDto,
  ContactSummaryDto,
  ContactUpdateDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiContacts = (
    contactCreateDto?: BodyType<ContactCreateDto>,
 signal?: AbortSignal
) => {


      return customInstance<ContactSummaryDto>(
      {url: `/api/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactCreateDto, signal
    },
      );
    }




export const getPostApiContactsMutationKey = () => ['postApiContacts'] as const;

export const getPostApiContactsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiContacts>>, TError,PostApiContactsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiContacts>>, TError,PostApiContactsMutationVariables, TContext> => {

const mutationKey = getPostApiContactsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiContacts>>, PostApiContactsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiContacts(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiContacts>>>
    export type PostApiContactsMutationBody = BodyType<ContactCreateDto> | undefined
    export type PostApiContactsMutationError = ErrorType<unknown>
    export type PostApiContactsMutationVariables = {data?: BodyType<ContactCreateDto>}

    export const usePostApiContacts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiContacts>>, TError,PostApiContactsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiContacts>>,
        TError,
        PostApiContactsMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiContactsMutationOptions(options), queryClient);
    }
    export const putApiContacts = (
    contactUpdateDto?: BodyType<ContactUpdateDto>,
 signal?: AbortSignal
) => {


      return customInstance<ContactSummaryDto>(
      {url: `/api/contacts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contactUpdateDto, signal
    },
      );
    }




export const getPutApiContactsMutationKey = () => ['putApiContacts'] as const;

export const getPutApiContactsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiContacts>>, TError,PutApiContactsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiContacts>>, TError,PutApiContactsMutationVariables, TContext> => {

const mutationKey = getPutApiContactsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiContacts>>, PutApiContactsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiContacts(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiContactsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiContacts>>>
    export type PutApiContactsMutationBody = BodyType<ContactUpdateDto> | undefined
    export type PutApiContactsMutationError = ErrorType<unknown>
    export type PutApiContactsMutationVariables = {data?: BodyType<ContactUpdateDto>}

    export const usePutApiContacts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiContacts>>, TError,PutApiContactsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiContacts>>,
        TError,
        PutApiContactsMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiContactsMutationOptions(options), queryClient);
    }
    export const getApiContactsCustomerCustomerNumber = (
    customerNumber: number,
 signal?: AbortSignal
) => {


      return customInstance<ContactSummaryDto[]>(
      {url: `/api/contacts/customer/${customerNumber}`, method: 'GET', signal
    },
      );
    }




export const getGetApiContactsCustomerCustomerNumberQueryKey = (customerNumber: number,) => {
    return [
    `/api/contacts/customer/${customerNumber}`
    ] as const;
    }


export const getGetApiContactsCustomerCustomerNumberQueryOptions = <TData = Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError = ErrorType<unknown>>(customerNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiContactsCustomerCustomerNumberQueryKey(customerNumber);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>> = ({ signal }) => getApiContactsCustomerCustomerNumber(customerNumber, signal);





   return  { queryKey, queryFn, enabled: customerNumber !== null && customerNumber !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiContactsCustomerCustomerNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>>
export type GetApiContactsCustomerCustomerNumberQueryError = ErrorType<unknown>


export function useGetApiContactsCustomerCustomerNumber<TData = Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError = ErrorType<unknown>>(
 customerNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>,
          TError,
          Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiContactsCustomerCustomerNumber<TData = Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError = ErrorType<unknown>>(
 customerNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>,
          TError,
          Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiContactsCustomerCustomerNumber<TData = Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError = ErrorType<unknown>>(
 customerNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiContactsCustomerCustomerNumber<TData = Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError = ErrorType<unknown>>(
 customerNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsCustomerCustomerNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiContactsCustomerCustomerNumberQueryOptions(customerNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiContactsContactId = (
    contactId: number,
 signal?: AbortSignal
) => {


      return customInstance<ContactSummaryDto>(
      {url: `/api/contacts/${contactId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiContactsContactIdQueryKey = (contactId: number,) => {
    return [
    `/api/contacts/${contactId}`
    ] as const;
    }


export const getGetApiContactsContactIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiContactsContactId>>, TError = ErrorType<unknown>>(contactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsContactId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiContactsContactIdQueryKey(contactId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiContactsContactId>>> = ({ signal }) => getApiContactsContactId(contactId, signal);





   return  { queryKey, queryFn, enabled: contactId !== null && contactId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiContactsContactId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiContactsContactIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiContactsContactId>>>
export type GetApiContactsContactIdQueryError = ErrorType<unknown>


export function useGetApiContactsContactId<TData = Awaited<ReturnType<typeof getApiContactsContactId>>, TError = ErrorType<unknown>>(
 contactId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsContactId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiContactsContactId>>,
          TError,
          Awaited<ReturnType<typeof getApiContactsContactId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiContactsContactId<TData = Awaited<ReturnType<typeof getApiContactsContactId>>, TError = ErrorType<unknown>>(
 contactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsContactId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiContactsContactId>>,
          TError,
          Awaited<ReturnType<typeof getApiContactsContactId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiContactsContactId<TData = Awaited<ReturnType<typeof getApiContactsContactId>>, TError = ErrorType<unknown>>(
 contactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsContactId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiContactsContactId<TData = Awaited<ReturnType<typeof getApiContactsContactId>>, TError = ErrorType<unknown>>(
 contactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiContactsContactId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiContactsContactIdQueryOptions(contactId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiContactsContactId = (
    contactId: number,
 signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/contacts/${contactId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiContactsContactIdMutationKey = () => ['deleteApiContactsContactId'] as const;

export const getDeleteApiContactsContactIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiContactsContactId>>, TError,DeleteApiContactsContactIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiContactsContactId>>, TError,DeleteApiContactsContactIdMutationVariables, TContext> => {

const mutationKey = getDeleteApiContactsContactIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiContactsContactId>>, DeleteApiContactsContactIdMutationVariables> = (props) => {
          const {contactId} = props ?? {};

          return  deleteApiContactsContactId(contactId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiContactsContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiContactsContactId>>>

    export type DeleteApiContactsContactIdMutationError = ErrorType<unknown>
    export type DeleteApiContactsContactIdMutationVariables = {contactId: number}

    export const useDeleteApiContactsContactId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiContactsContactId>>, TError,DeleteApiContactsContactIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiContactsContactId>>,
        TError,
        DeleteApiContactsContactIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteApiContactsContactIdMutationOptions(options), queryClient);
    }
